import { Building2 } from "lucide-react";
import { useTranslate } from "ra-core";
import { Link } from "react-router";
import { Button } from "@/components/ui/button";

/**
 * Friendly empty state shown when there are no companies yet.
 */
export const DashboardEmpty = () => {
  const translate = useTranslate();
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-16 text-center">
      <Building2 className="w-10 h-10 text-muted-foreground" />
      <div className="flex flex-col gap-1 items-center">
        <h2 className="text-xl font-semibold">
          {translate("crm.dashboard.empty.title")}
        </h2>
        <p className="max-w-md text-sm text-muted-foreground">
          {translate("crm.dashboard.empty.description")}
        </p>
      </div>
      <Button asChild>
        <Link to="/companies/create">
          {translate("crm.dashboard.empty.add_company")}
        </Link>
      </Button>
    </div>
  );
};
